import * as types from 'store/actions/types';
import * as fetchMembershipPools from 'store/actions/membership-pools/fetchMembershipPools';
import * as createMembershipPools from 'store/actions/membership-pools/createMembershipPools';
import * as deleteMembershipPools from 'store/actions/membership-pools/deleteMembershipPools';
import * as updateMembershipPools from 'store/actions/membership-pools/updateMembershipPools';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import utils from 'helpers/utils';

function* failureMessage({ error }) {
    const { message } = error.response || {};

    yield put(showNotification(message || 'general.error', 'warning'));
}

function* fetchMembershipPoolsAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/user-product-membership-pools`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchMembershipPools.fetchMembershipPoolsSuccess(response));
    } catch (error) {
        yield put(fetchMembershipPools.fetchMembershipPoolsFailure(error));
    }
}

function* fetchMembershipPoolAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/user-product-membership-pools/${ id }`;

        const response = yield apiClient.read(url);

        yield put(fetchMembershipPools.fetchMembershipPoolSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }

    } catch (error) {
        yield put(fetchMembershipPools.fetchMembershipPoolFailure(error));

        if (utils.isFunction(error)) {
            yield onError(error);
        }
    }
}

function* createMembershipAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/user-product-membership-pools`;

        const response = yield apiClient.create(url, values);

        yield put(createMembershipPools.createMembershipPoolSuccess(response));

        yield onSuccess();
    } catch (error) {
        yield put(createMembershipPools.createMembershipPoolFailure(error));

        yield onError(error);
    }
}

function* createMembershipPoolSuccessAsync() {
    yield put(showNotification('resources.memberships.messages.created.success', 'success'));
}

function* deleteMembershipPoolAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/user-product-membership-pools/${ id }`;

        yield apiClient.delete(url);

        yield put(deleteMembershipPools.deleteMembershipPoolSuccess(payload));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(deleteMembershipPools.deleteMembershipPoolFailure(error));

        if (utils.isFunction(error)) {
            yield onError(error);
        }
    }
}

function* updateMembershipPoolAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/user-product-membership-pools/${ id }`;

        const response = yield apiClient.patch(url, values);

        yield put(updateMembershipPools.updateMembershipPoolSuccess(payload, response));

        yield onSuccess();
    } catch (error) {
        yield put(updateMembershipPools.updateMembershipPoolFailure(error));

        yield onError(error);
    }
}

function* updateMembershipPoolSuccessAsync() {
    yield put(showNotification('resources.memberships.messages.updated.success', 'success'));
}

function* deleteMembershipPoolSuccessAsync() {
    yield put(showNotification('resources.memberships.messages.deleted.success', 'success'));
}

export default function* membershipsPoolsSagas() {
    yield [
        takeEvery(types.FETCH_MEMBERSHIP_POOLS, fetchMembershipPoolsAsync),
        takeEvery(types.FETCH_MEMBERSHIP_POOLS_FAILURE, failureMessage),

        takeEvery(types.FETCH_MEMBERSHIP_POOL, fetchMembershipPoolAsync),
        takeEvery(types.FETCH_MEMBERSHIP_POOL_FAILURE, failureMessage),

        takeEvery(types.CREATE_MEMBERSHIP_POOL, createMembershipAsync),
        takeEvery(types.CREATE_MEMBERSHIP_POOL_FAILURE, failureMessage),
        takeEvery(types.CREATE_MEMBERSHIP_POOL_SUCCESS, createMembershipPoolSuccessAsync),

        takeEvery(types.UPDATE_MEMBERSHIP_POOL, updateMembershipPoolAsync),
        takeEvery(types.UPDATE_MEMBERSHIP_POOL_FAILURE, failureMessage),
        takeEvery(types.UPDATE_MEMBERSHIP_POOL_SUCCESS, updateMembershipPoolSuccessAsync),

        takeEvery(types.DELETE_MEMBERSHIP_POOL, deleteMembershipPoolAsync),
        takeEvery(types.DELETE_MEMBERSHIP_POOL_FAILURE, failureMessage),
        takeEvery(types.DELETE_MEMBERSHIP_POOL_SUCCESS, deleteMembershipPoolSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/memberships/membershipPoolsSagas.js